import { createPinia } from "pinia";
import { createApp } from "vue";
import {
  Alert,
  Button,
  Card,
  Checkbox,
  Col,
  Descriptions,
  Drawer,
  Dropdown,
  Empty,
  Form,
  Input,
  InputNumber,
  Layout,
  Menu,
  Modal,
  Popconfirm,
  Row,
  Select,
  Space,
  Statistic,
  Switch,
  Table,
  Tag,
  Typography
} from "ant-design-vue";
import "ant-design-vue/dist/reset.css";
import App from "./App.vue";
import { runtimeConfig, validateRuntimeConfig } from "./runtime-config";
import { router } from "./router";
import "./styles/admin.scss";

const runtimeValidation = validateRuntimeConfig(runtimeConfig);

if (!runtimeValidation.ok) {
  renderRuntimeConfigError(runtimeValidation.errors);
} else {
  const app = createApp(App);

  app.use(createPinia());
  [
    Alert,
    Button,
    Card,
    Checkbox,
    Col,
    Descriptions,
    Drawer,
    Dropdown,
    Empty,
    Form,
    Input,
    InputNumber,
    Layout,
    Menu,
    Modal,
    Popconfirm,
    Row,
    Select,
    Space,
    Statistic,
    Switch,
    Table,
    Tag,
    Typography
  ].forEach((component) => app.use(component));
  app.use(router);
  app.mount("#app");
}

function renderRuntimeConfigError(errors: string[]) {
  const root = document.querySelector("#app");
  if (!root) {
    return;
  }

  root.innerHTML = `
    <main class="admin-config-error">
      <section>
        <p>启动配置需要确认</p>
        <h1>管理后台还没有连到正式后端</h1>
        <ul>${errors.map((error) => `<li>${escapeHtml(error)}</li>`).join("")}</ul>
      </section>
    </main>
  `;
}

function escapeHtml(value: string) {
  const replacements: Record<string, string> = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    "\"": "&quot;",
    "'": "&#39;"
  };
  return value.replace(/[&<>"']/g, (char) => replacements[char]);
}
